import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'user-editor-page-header',
    template: `
        <div class="page-header ExtraLightBackgroundColor">
          <button type="button" class="back-button" mat-icon-button (click)="back()">
            <span class="fas fa-arrow-left"></span>
          </button>
        
          <span class="page-header-text">{{ getUserEditorHeading() }}</span>
        
          @if (isAccessRequesting) {
            <button
              type="button"
              mat-raised-button
              class="right-aligned BrandedBackgroundColor left-offset"
              (click)="acceptUserRequest()"
              >
              {{ 'accept' | fiAppText }}
            </button>
            <button
              type="button"
              mat-raised-button
              class="reject-user-request right-aligned"
              (click)="rejectUserRequest()"
              >
              <mat-icon class="far fa-trash" />
              {{ 'common_discard_reject' | fiAppText }}
            </button>
          } @else {
            <button
              type="button"
              mat-raised-button
              class="right-aligned BrandedBackgroundColor"
              (click)="saveUser()"
              >
              {{ 'common.save' | fiAppText }}
            </button>
          }
        
        </div>
        `,
    styleUrls: ['./user-editor-page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'user-editor-page-header' },
    standalone: false,
})
export class UserEditorPageHeaderComponent {
    @Input() userId: number;
    @Input() isAccessRequesting: boolean;
    @Output() onAcceptUserRequest = new EventEmitter<void>();
    @Output() onRejectUserRequest = new EventEmitter<void>();
    @Output() onUserSave = new EventEmitter<void>();
    constructor(private appTextService: AppTextService) {}

    getUserEditorHeading(): string {
        if (this.isAccessRequesting) return this.appTextService.get('user.edit_user_request');

        return this.appTextService.get(this.userId ? 'user.edit_profile' : 'common.new_user');
    }

    back() {
        window.history.back();
    }

    acceptUserRequest() {
        this.onAcceptUserRequest.emit();
    }

    rejectUserRequest() {
        this.onRejectUserRequest.emit();
    }

    saveUser() {
        this.onUserSave.emit();
    }
}
